import { useLoaderData } from 'react-router';
import { useSearchParams } from '../../../../../common/hooks/useSearchParams';
import { MobileIdNewContent } from '../../../../../components/MobileId/MobileIdNew.js';
import type { Contract } from '../../../../../generated/api/contract';

export const MobileIdNewPath = () => {
  const mobileIdContracts = useLoaderData() as Contract[];
  const { mdmId } = useSearchParams<{ mdmId?: string }>();

  return <MobileIdNewContent mdmId={mdmId!} mobileIdContracts={mobileIdContracts} />;
};
